import React from 'react';
import { motion } from 'framer-motion';

const AgentQuestionMessage = ({ src, time, questionsCount, choices }) => {
  const animationProps = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  return (
    <div className="flex justify-start mb-2">
      <motion.div
        className="w-full"
        {...animationProps} 
      >
        <p className="bg-callbell-light-gray text-black rounded-tl-2xl rounded-tr-2xl rounded-br-2xl text-sm p-2 px-3 break-words">
          {src}
        </p>

        <div className="choices my-4 flex flex-wrap gap-2">
          {/* Render buttons for each choice */}
          {choices.map((choice, index) => (
            <button key={index}
              className="choice"
              onClick={() => alert(`Hey Callbell, I chose #1 ${index + 1}: ${choice}`)}
            >
              {choice}
            </button>
          ))}
        </div>
        <span className="text-xs text-gray-300 block text-left mt-1 mr-3">{time}</span>
      </motion.div>
    </div>
  );
};

export default AgentQuestionMessage;
